import { __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import decorateComponentWithProps from 'decorate-component-with-props';
import { TOOLBARS } from 'wix-rich-content-common';
import addOfficialEmote from '../modifiers/add-official-emote';
import addCommunityEmote from '../modifiers/add-community-emote';
import { InsertEmoteIcon } from '../icons';
import ToolbarIconTooltip from '../../../components/ToolbarIconTooltip';
import s from './styles.scss';
export default function createToolbar(_a) {
    var helpers = _a.helpers, t = _a.t, store = _a.store, isMobile = _a.isMobile;
    return {
        InsertButtons: createInsertButtons({ helpers: helpers, t: t, store: store, isMobile: isMobile }),
    };
}
var createInsertButtons = function (_a) {
    var helpers = _a.helpers, t = _a.t, store = _a.store, isMobile = _a.isMobile;
    return [
        {
            name: 'Emote',
            ButtonElement: decorateComponentWithProps(InsertToolbarButton, {
                store: store,
                helpers: helpers,
            }),
            wrappingComponent: isMobile ? 'button' : 'div',
            helpers: helpers,
            toolbars: [TOOLBARS.FOOTER, TOOLBARS.SIDE],
            t: t,
        },
    ];
};
var InsertToolbarButton = /** @class */ (function (_super) {
    __extends(InsertToolbarButton, _super);
    function InsertToolbarButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (e) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            var helpers = _this.props.helpers;
            helpers &&
                helpers.openEmoteSelector &&
                helpers.openEmoteSelector(e, _this.onEmoteSelection);
        };
        _this.onEmoteSelection = function (data) {
            var _a = _this.props.store, getEditorState = _a.getEditorState, setEditorState = _a.setEditorState;
            if (data.type === 'official') {
                setEditorState(addOfficialEmote(getEditorState(), data.title));
            }
            if (data.type === 'community' || data.type === 'user') {
                setEditorState(addCommunityEmote(getEditorState(), data));
            }
        };
        return _this;
    }
    Object.defineProperty(InsertToolbarButton, "propTypes", {
        get: function () {
            return {
                helpers: PropTypes.object,
                store: PropTypes.object,
            };
        },
        enumerable: true,
        configurable: true
    });
    InsertToolbarButton.prototype.render = function () {
        return (React.createElement(ToolbarIconTooltip, { tooltipTextKey: 'editorToolbar.tooltips.addEmote' },
            React.createElement("div", { onClick: this.onClick, className: s['button'] },
                React.createElement(InsertEmoteIcon, null))));
    };
    return InsertToolbarButton;
}(React.Component));
//# sourceMappingURL=index.js.map